import React from 'react'

const Title = ({Name,BackURL}) => {
  return (
    <div className='forms_title_wrapper'>
      <div className='forms_title_container'>
        {BackURL &&
            <div className='forms_title_button'>

            </div>
        }
        <div className='forms_title_text'>
            <h5>{Name}</h5>
        </div>
      </div>
    </div>
  )
}

export default Title
